import AICoverLetters from 'pagecomponents/AICoverLetters';
export default Object.assign(AICoverLetters, { requiresPlacesApi: false });
